import React, { useState } from "react";
import { FileText } from "lucide-react";
import { Pill } from "../common/Pill";
import { DownloadLink } from "../common/DownloadLink";
import { docTypeLabel } from "../../utils";

export interface DocVersion {
  version: number;
  date: string;
  filename: string;
  fileData?: string;
  uploaded?: boolean;
  source_email_id?: number;
  content?: string;
}

export interface DocRegisterEntry {
  id?: string;
  name: string;
  doc_type: string;
  current_version: number;
  status?: string;
  bears_on?: string[];
  versions?: DocVersion[];
}

export interface DocRegisterCardProps {
  d: DocRegisterEntry;
}

/* One document in a workstream's document register — name, type, version,
   status pill, version history toggle. */
export function DocRegisterCard({ d }: DocRegisterCardProps): JSX.Element {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <div className="docregcard">
      <div className="drhd">
        <FileText size={14} color="var(--muted)" />
        <div className="drnm">{d.name}</div>
        <Pill
          color={d.status === "executed" ? "--green" : d.status === "conformed" ? "--blue" : "--amber"}
          label={d.status || "draft"}
        />
      </div>
      <div className="drmeta">
        <span className="mono">{docTypeLabel(d.doc_type)}</span>
        <span>·</span>
        <span className="mono">
          v{d.current_version} · {(d.versions || []).length} version
          {(d.versions || []).length === 1 ? "" : "s"}
        </span>
      </div>
      {(d.bears_on || []).length > 0 && (
        <div className="drbo">
          <span className="tert">Bears on:</span> {(d.bears_on || []).join(", ")}
        </div>
      )}
      <div style={{ marginTop: 6 }}>
        <button className="lnk" onClick={() => setOpen(!open)}>
          {open ? "Hide" : "Show"} version history
        </button>
      </div>
      {open && (
        <div className="drvers">
          {(d.versions || []).map((v, vi) => (
            <div key={vi} className="drver">
              <span className="v">v{v.version}</span>
              <span className="mono" style={{ fontSize: 11 }}>
                {v.filename}
              </span>
              <span>·</span>
              <span>{v.date}</span>
              <span>·</span>
              <span className="tert">
                {v.uploaded ? "uploaded" : "from email #" + v.source_email_id}
              </span>
              <span style={{ marginLeft: "auto" }}>
                <DownloadLink doc={v} size={11} variant="sm" />
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
